module.exports = __webpack_public_path__ + "img/shane-gunnell.951a7d4c.png";